module.exports = __webpack_public_path__ + "media/images/arrow-down-6e671b2f9d7a1124d0a1acb680625c0a.svg";